import { voteApi } from "api/vote.api";
import { useState } from "react";
import { Vote } from "types/vote";
import { QueryParam } from "types/query";

export interface VoteQuery extends QueryParam {}

export const useVote = () => {
  const [data, setData] = useState<Vote[]>([]);
  const [total, setTotal] = useState(0);

  const fetchData = async (query: VoteQuery) => {
    const { data } = await voteApi.findAll(query);

    setData(data.votes);
    setTotal(data.total);
  };

  return { votes: data, total, fetchData };
};
